import { Component, Inject, ViewEncapsulation, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface TituloExtraido {
  tag: string;
  text: string;
}

@Component({
  selector: 'app-dialog-oporunidades-externos',
  templateUrl: './dialog-oporunidades-externos.component.html',
  styleUrls: ['./dialog-oporunidades-externos.component.css'],
})
export class DialogOporunidadesExternosComponent implements OnInit {
  htmlContent!: SafeHtml;
  estadoKeys: string[] = [];
  iconType = 'info';
  iconColor = 'white';
  showIcon = true;
  sinPermiso = false;
  titulos: TituloExtraido[] = []; // ⬅️ Ahora es un arreglo de objetos
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { conteo: any; template: string },
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DialogOporunidadesExternosComponent>
  ) {}

  ngOnInit() {
    // ✅ Sanitizar el HTML para evitar problemas de seguridad
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(
      this.data.template
    );

    // ✅ Parsear el HTML de la plantilla
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.data.template, 'text/html');

    this.titulos = [];

    // 🔎 1) Buscar h1 y h2
    const headings = doc.querySelectorAll('h1, h2');
    headings.forEach((el) => {
      const texto = el.textContent?.trim();
      if (texto) {
        this.titulos.push({ tag: el.tagName.toLowerCase(), text: texto });
      }
    });

    // 🔎 2) Buscar todos los párrafos
    const parrafos = doc.querySelectorAll('p');
    parrafos.forEach((el) => {
      const texto = el.textContent?.trim();
      if (texto) {
        this.titulos.push({ tag: el.tagName.toLowerCase(), text: texto });
      }
    });

    // 🆘 Si no se encontró nada, asignar un título genérico
    if (this.titulos.length === 0) {
      this.titulos = [{ tag: 'h2', text: 'Alerta' }];
    }

    // 📊 Extraer estados y combinarlos con el conteo
    const estadosDesdeHtml = Array.from(doc.querySelectorAll('.bloque-fijo div'))
      .map((el) => (el.textContent || '').split(/–|-/)[0].trim())
      .filter((e) => e.length > 0);

    const conteoKeys = this.data.conteo ? Object.keys(this.data.conteo) : [];
    this.estadoKeys = [...new Set([...conteoKeys, ...estadosDesdeHtml])];
  }
}
